<template>
  <tk-container class="project" :status="status" @refresh="initData">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      {{project.username || ''}}
    </tkui-header>
    <div class="body">
      <tk-flex class="items" @click.native="toDetail(item)" v-for="(item, index) in machines" :key="index">
        <div class="leftBar full-height unshrink"></div>
        <div class="app-content">
          <h2 class="itemName">{{item.name}}</h2>
          <p class="des">型号：{{item.type}}</p>
          <tk-flex top>
            <div class="location unshrink">
              <tk-icon style="width: 15px;color: #008DFF;">location</tk-icon>
            </div>
            <span class="address fill">地址描述：{{item.address}}</span>
          </tk-flex>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        machines: []
      }
    },
    computed: {
      project () {
        return this.$store.state.appproject || {}
      }
    },
    created () {
      this.initData()
    },
    methods: {
      back () {
        this.$back()
      },
      async initData () {
        this.status = 'loading'
        try {
          let machines = await this.$tkParse.getList('/classes/machine', {
            params: {
              where: {
                client: this.project.objectId
              },
              include: 'dealer',
              limit: 2000,
              order: '-status, createdAt'
            }
          })
          this.machines = machines
          this.status = !machines.length ? 'empty' : false
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      toDetail (machine) {
        this.$store.commit('setMachine', machine)
        this.$push('/detail')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .project{
    .body{
      padding: 15px;
      .items{
        width: 100%;
        height: 110px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 10px;
        .leftBar{
          width: 25px;
          border-radius: 50%;
          margin-left: -15px;
          background: #008DFF;
        }
        .app-content{
          padding: 15px;
          .itemName{
            font-size: 18px;
            color: #233038;
          }
          .des,.address{
            font-size: 14px;
            color: #999999;
            line-height: 24px;
            margin-bottom: 0 !important;
          }
          .location{
            width: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/project/machines.vue